import { Container } from '@/Components/Container'
import {InertiaLink} from "@inertiajs/inertia-react";
import React, {useEffect} from "react";
import {Emma} from "@/Components";
import {Subheader} from "@/Components";

const HeroBlock = () => {

    const [hello, setHello] = React.useState(null);

    useEffect(() => {
      const interval = setInterval(() => {
        setHello(hello ? null : 'Hello! :)');
      }, 10000);
      return () => clearInterval(interval);
    }, [hello]);

    return <div className="heroBlock pt-8 md:pt-16 bg-background">
        <Container size="max-w-[834px]" className="relative">
            <Subheader className="font-normal">LESS TALKING, MORE DOING</Subheader>
            <div className="flex justify-between">
              <h1 className="tracking-tight text-[34px] leading-[40px] md:text-[48px] md:leading-[56px] text-[#363636]">
                Accelerate climate action with Emma
              </h1>
              <Emma className="self-end flex-shrink hidden w-1/3 sm:block" color="green" tooltip={hello} />
            </div>

            <p className="block mt-4 text-[18px] text-[#363636] font-normal mb-4 md:w-3/4">
                Whether you need help collecting climate data from internal or external sources,
                navigating sustainability regulations like ESG, CSRD, GRI or understanding your
                climate impact, Emma assists both small and large companies in streamlining
                climate data collection and sustainability reporting.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
                <InertiaLink href="/book-a-demo" className="btn py-3 px-4 text-[14px] font-bold max-w-max">
                    Book a demo
                </InertiaLink>

                <InertiaLink href="/plans" className="btn py-3 px-4 text-[14px] font-bold max-w-max">
                    Start your emission accounting
                </InertiaLink>
            </div>

        </Container>
    </div>
}

export default HeroBlock
